import { useQuery } from '@apollo/client';
import { AccountClient, useProduct } from '../../../index';
import { GET_CLIENT_SITE_LIST } from '../../../DeviceGraphQL/queries/MDMSettingsPage';
import { GET_COMPANY_SITE_LIST } from '@nile/itsm/src/graphql';

//Loading.
export const useClientSites = (clientId: string) => {
  const isMSPProduct = useProduct('MSP');
  const query = isMSPProduct ? GET_CLIENT_SITE_LIST : GET_COMPANY_SITE_LIST;

  const { data, loading, error } = useQuery(query, {
    ...(isMSPProduct && {
      variables: {
        input: {
          sort: [
            {
              attribute: 'name',
              order: 'ASC'
            }
          ],
          condition: {
            joinOperator: 'AND',
            operands: [
              {
                value: clientId || '',
                operator: 'is',
                attribute: 'account.accountId'
              }
            ]
          }
        }
      }
    }),
    client: AccountClient
  });

  // Convert sites to dropdown options
  const siteOptions =
    data?.[
      isMSPProduct ? 'getClientSiteList' : 'getCompanySiteList'
    ]?.sites?.map((site) => ({
      label: site.name,
      value: site.id
    })) || [];

  return {
    siteOptions,
    loading,
    error
  };
};
